/**
 * Environment Configuration
 * Centralized configuration for environment variables
 */

const config = {
  // API Configuration
  api: {
    baseURL: process.env.REACT_APP_API_URL || 'https://team-agua-website-functions-fxcwfth5gndncydt.westeurope-01.azurewebsites.net/api',
    timeout: parseInt(process.env.REACT_APP_API_TIMEOUT || '30000', 10),
  },

  // App Configuration
  app: {
    name: process.env.REACT_APP_NAME || 'Team Agua',
    environment: process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development',
    port: parseInt(process.env.PORT || '5020', 10),
    version: process.env.REACT_APP_VERSION || '1.0.0',
  },

  // Feature Flags
  features: {
    enableAnalytics: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
    enableDebugMode: process.env.REACT_APP_DEBUG_MODE === 'true' || process.env.NODE_ENV === 'development',
  },

  // Default Settings
  defaults: {
    language: process.env.REACT_APP_DEFAULT_LANGUAGE || 'nl',
  },

  // External URLs
  externalUrls: {
    signupUrl: process.env.REACT_APP_SIGNUP_URL || 'https://www.paynplan.nl/p/40088',
  },
};

// Validation (optional but recommended)
const validateConfig = () => {
  const missing = [];

  if (!config.api.baseURL) {
    missing.push('REACT_APP_API_URL');
  }

  if (missing.length > 0) {
    console.warn('Missing required environment variables:', missing);
  }
};

// Run validation in development
if (config.app.environment === 'development') {
  validateConfig();
}

export default config;
